import {Stack, Typography} from '@mui/material';
import React, {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {AlertActions, AlertModal, ProductLogo} from 'presentation/components';
import {HomeEnum, SelectionFlowEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

import {ChangePlanDialog} from 'presentation/components/ChangePlanDialog';
import {useMediaQueries} from 'presentation/pages/private';
import {useSteps} from '../../hooks/useSteps';
import {useIsComingFromInitialFlowStore} from '../../store/useIsComingFromInitialFlowStore';
import {useSelectedBeneficiaryStore} from '../../store/useSelectedBeneficiaryStore';
import {HeaderContainer, HeaderNavbar, StyledIconButton} from './styles';

const {flowExitModal, discard} = translations['pt-br'].others.selectionFlow;
const {cancel} = translations['pt-br'].commons;

export function SelectionHeader() {
	const {isTablet} = useMediaQueries();
	const resetSelectedBeneficiary = useSelectedBeneficiaryStore(
		state => state.resetSelectedBeneficiary,
	);
	const [flowExitModalOpen, setFlowExitModalOpen] = useState(false);
	const [showChangePlanDialogState, setShowChangePlanDialogState] = useState<boolean>(false);
	const isComingFromInitialFlow = useIsComingFromInitialFlowStore(
		state => state.isComingFromInitialFlow,
	);
	const {currentStep, isFirstAccess} = useSteps();
	const navigate = useNavigate();
	const {state} = useLocation();

	const {stepNumber, title} = currentStep;

	const handleGoBack = () => {
		if (stepNumber === 3) {
			resetSelectedBeneficiary();
			return navigate(SelectionFlowEnum.BENEFICIARY_SELECTION, {
				state: {
					...state,
					isCommingFromLoginPaths: true,
				},
			});
		}

		if (stepNumber === 2 && isComingFromInitialFlow) return setShowChangePlanDialogState(true);

		if (stepNumber === 2) {
			return navigate(SelectionFlowEnum.PLAN_SELECTION, {
				state: {
					...state,
					isCommingFromLoginPaths: true,
				},
			});
		}

		return navigate(-1);
	};

	const handleCloseSelection = () => {
		if (stepNumber !== 1) return setFlowExitModalOpen(true);
		resetSelectedBeneficiary();
		if (state && state?.pathFrom) {
			return navigate(state?.pathFrom);
		}
		return navigate(HomeEnum.HOME_PAGE);
	};

	const handleFlowExit = () => {
		resetSelectedBeneficiary();
		if (state && state.pathFrom) {
			navigate(state.pathFrom);
			return;
		}
		navigate(HomeEnum.HOME_PAGE);
	};

	const handleCloseFlowExitModal = () => {
		setFlowExitModalOpen(false);
	};

	const SHOW_ARROW_BACK = (!isTablet && stepNumber !== 1) || (isTablet && !isFirstAccess);

	return (
		<HeaderContainer>
			{isTablet && isFirstAccess ? (
				<Stack paddingX={2} paddingTop={1} alignItems="flex-start">
					<ProductLogo invertColor />
				</Stack>
			) : null}
			<HeaderNavbar>
				<Stack direction="row" alignItems="center">
					{SHOW_ARROW_BACK ? (
						<StyledIconButton color="inherit" onClick={handleGoBack}>
							<Icon name="arrow-left-filled" />
						</StyledIconButton>
					) : null}
					<Typography marginLeft={1} variant={isTablet ? 'h6' : 'h5'}>
						{title}
					</Typography>
				</Stack>
				{!isFirstAccess ? (
					<StyledIconButton color="inherit" onClick={handleCloseSelection}>
						<Icon name="close-filled" />
					</StyledIconButton>
				) : null}
			</HeaderNavbar>
			<AlertModal
				footerContent={
					<AlertActions
						secondaryAction={handleCloseFlowExitModal}
						primaryAction={handleFlowExit}
						secondaryBtnVariant="text"
						secondaryText={cancel}
						primaryText={discard}
					/>
				}
				description={flowExitModal.description}
				headerTitle={flowExitModal.headerTitle}
				onClose={() => setFlowExitModalOpen(false)}
				title={flowExitModal.title}
				open={flowExitModalOpen}
				variant="warning"
			/>
			<ChangePlanDialog
				open={showChangePlanDialogState}
				setOpen={setShowChangePlanDialogState}
			/>
		</HeaderContainer>
	);
}
